import type { CreateBoardReq } from '@/api';

import type { BoardTemplate, BoardTemplateKey } from '../types/template';

/**
 * 템플릿의 i18n 키를 현재 언어 평문으로 해석해 보드 생성 payload 로 변환한다.
 * 생성된 title/notice/group.name 은 백엔드에 그대로 저장되므로 생성 시점 언어로 고정된다.
 */
export function templateToCreateBoardReq(
  template: BoardTemplate,
  t: (key: BoardTemplateKey) => string,
): CreateBoardReq {
  return {
    title: t(template.nameKey),
    emoji: template.emoji,
    groups: template.groups.map(group => ({
      name: t(group.nameKey),
      emoji: group.emoji,
    })),
    notices: template.noticeKey ? [{ content: t(template.noticeKey) }] : [],
  };
}
